import React from "react";

import type { JSX } from "react";

interface MapTooltipRowProps {
  label: string;
  value: string;
}

function MapTooltipRow({ label, value }: MapTooltipRowProps): JSX.Element {
  return (
    <div className="flex justify-between gap-4">
      <span className="text-muted-foreground">{label}</span>
      <span className="text-foreground font-mono font-medium tabular-nums">
        {value}
      </span>
    </div>
  );
}

export default MapTooltipRow;
